import React, {useContext, useState, useEffect} from 'react'
import {Languages} from "./Home"
import "../styles/cerchiCasa.scss"
import img from "../assets/immagini/image_cerchi_casa.webp"

export default function CerchiCasa() {
    const lang = useContext(Languages)

    const posizionePartenza = -300
    const dimensioni = [1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500, 1500, 1500, 1500, 1500, 1500 ,1500 ,1500, 1500]
    const idealWidth = 1920;
    const maxWidth = 330;
    const minWidth = 165;

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    // Funzione per gestire il cambiamento delle dimensioni della finestra
    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    // Effetto per aggiungere e rimuovere l'ascolto degli eventi di ridimensionamento
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Pulisci l'ascoltatore degli eventi al momento della disconnessione dell'effetto
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Calcola la proporzione in base alla larghezza attuale della finestra
    const proportion = screenWidth / idealWidth /2;

    return (
        <div className='cerchi_casa_section max-w' >
            <div className='cerchi_casa_descrizione' data-aos="zoom-out-up" data-aos-duration="1000">
                <h3 className='titolo_sezione'>{lang["PERCHÉ L’ENNESIMA AGENZIA?"]}</h3>
                <div className=''>
                    <p className='testo_generico'>
                        {/*{lang["Perché quando eravamo noi i clienti, non abbiamo trovato nelle agenzie"]}<br/>
                        {lang["Vogliamo essere l'agenzia che avremmo voluto trovare quando serviva a noi."]}*/}
                        <b>Blend nasce dall'insoddisfazione. <br />
                        Quella che abbiamo provato quando i clienti eravamo noi. </b><br /><br /><br />
                        
                        Abbiamo avuto con le agenzie immobiliari esperienze non sempre gradevoli, fatte di spiegazioni approssimative, scarsa chiarezza delle procedure e tanta cavillosa burocrazia.<br /> 
                        Le sorprese sono belle al compleanno, non quando stai per spendere tanti soldi per comprare una casa.  <br /><br />
                        <b>E così abbiamo creato la nostra agenzia.</b> Blend è l’unione di
                        <b> architetti, tecnici, pubblicitari, agenti immobiliari. </b>Ognuno con i propri anni di esperienza e con la propria competenza specifica, ma con una visione unica e condivisa:
                        <b> noi vogliamo essere l'agenzia che avremmo desiderato, quando ne avevamo bisogno.</b><br />
                        Questa è la nostra missione. Questo è il nostro perché.<br />

                        
                    </p>
                </div>
            </div>

            <span data-aos="flip-left" data-aos-duration="1000" data-aos-delay="500" id="img_1_home">
            <div className='cerchi_casa_immagine_container' >
                
                {dimensioni.map((elem, index) => {
            let width = 330 * proportion;
            let widthSubstract = 30 * proportion;
            widthSubstract = widthSubstract <= 30 ? widthSubstract : 30;
            widthSubstract = widthSubstract <= 15 ? 15 : widthSubstract;

            // Limita la larghezza massima a 330 e la larghezza minima a 180
            width = Math.min(Math.max(width, minWidth), maxWidth);

            // Calcola il ritardo per ciascuna colonna (ad esempio, 0.2s, 0.4s, 0.6s, ecc.)
            const delay = 0.2 * index + "s";

            // Applica la classe CSS e il ritardo
            const columnClassName = "column-riquadro c" + index + " column-animation-riquadro column_riquadro";
            const columnStyle = {
                left: posizionePartenza + width * index,
                height: elem,
                width: width - widthSubstract,
                animationDelay: delay, // Applica il ritardo all'animazione
            };
                return (
                    <div key={index} className={columnClassName} style={columnStyle}/>
                )
            })}
            </div>
            </span>
        </div>
    )
}
